<template>
  <audio
      :src="attachImageUrl(songUrl)"
      preload="true"
      :ref="player"
      @canplay="canplay"
      @timeupdate="timeupdate"
      @ended="ended"
  />
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { HttpManager } from "@/api";

export default defineComponent({
  setup() {
    const store = useStore();
    const divRef = ref<HTMLAudioElement | null>(null);
    const player = (el: HTMLAudioElement) => {
      divRef.value = el;
    };

    const songUrl = computed(() => store.getters.songUrl);
    const isPlay = computed(() => store.getters.isPlay);
    const volume = computed(() => store.getters.volume);
    const changeTime = computed(() => store.getters.changeTime);
    const autoNext = computed(() => store.getters.autoNext);

    // 切换歌曲时重新加载并尝试播放
    watch(songUrl, (newSongUrl) => {
      if (!divRef.value || !newSongUrl) return;

      divRef.value.src = HttpManager.attachImageUrl(newSongUrl);
      divRef.value.load();

      const playPromise = divRef.value.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.warn("播放失败，请检查用户交互状态", error);
          store.commit("setIsPlay", false);
        });
      }
    });

    // 监听播放状态变化
    watch(isPlay, () => togglePlay());

    // 跳转时间
    watch(changeTime, () => {
      if (divRef.value) {
        divRef.value.currentTime = changeTime.value;
      }
    });

    // 设置音量
    watch(volume, (value) => {
      if (divRef.value) {
        divRef.value.volume = value;
      }
    });

    function togglePlay() {
      if (!divRef.value) return;

      if (isPlay.value) {
        const playPromise = divRef.value.play();
        if (playPromise !== undefined) {
          playPromise.catch(err => {
            console.error("播放失败", err);
            store.commit("setIsPlay", false);
          });
        }
      } else {
        divRef.value.pause();
      }
    }

    function canplay() {
      if (!divRef.value) return;
      store.commit("setDuration", divRef.value.duration);
      store.commit("setIsPlay", true);
    }

    function timeupdate() {
      if (!divRef.value) return;
      store.commit("setCurTime", divRef.value.currentTime);
    }

    function ended() {
      store.commit("setIsPlay", false);
      store.commit("setCurTime", 0);
      store.commit("setAutoNext", !autoNext.value);
    }

    return {
      songUrl,
      player,
      canplay,
      timeupdate,
      ended,
      attachImageUrl: HttpManager.attachImageUrl,
    };
  },
});
</script>

<style scoped>
audio {
  display: none;
}
</style>
